import type {
    GetInsightFamiliesRequest,
    InsightFamily,
} from "@amzn/d16-g-client-deck-builder-typescript-client";
import type { AsyncState, UseAsyncActions } from "@react-hookz/web";
import { useAsyncAbortable } from "@react-hookz/web";

import { getCdbApiClient } from "../../api/cdbApi/cdbApi";
import { useAsyncErrorStatusNotification } from "../notifications/useAsyncErrorStatusNotification";

export interface InsightFamiliesActionProps {
    advertiserId?: string;
    marketplaceId?: string;
    familyName?: string;
}

export function useInsightFamiliesAction({
    advertiserId,
    marketplaceId,
    familyName,
}: InsightFamiliesActionProps = {}): [
    AsyncState<InsightFamily[]>,
    UseAsyncActions<InsightFamily[]>,
] {
    const request: GetInsightFamiliesRequest = {
        advertiserId,
        marketplaceId,
        familyName,
    };

    const [insightsState, insightsAction] = useAsyncAbortable(async () => {
        const { data } = await (
            await getCdbApiClient()
        ).getInsightFamilies(request);
        return data ?? [];
    }, []);

    useAsyncErrorStatusNotification(insightsState);

    return [insightsState, insightsAction];
}
